import { render, staticRenderFns } from "./storageList.vue?vue&type=template&id=264f2115&scoped=true&"
import script from "./storageList.vue?vue&type=script&lang=js&"
export * from "./storageList.vue?vue&type=script&lang=js&"
import style0 from "./storageList.vue?vue&type=style&index=0&id=264f2115&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "264f2115",
  null
  
)

export default component.exports